import WC from './WC'

export default {
  ...WC,
  extended: true,
}
